import * as React from 'react';
import { useTheme } from '../../../../theming/useTheme';
import { DividedCardComponent, DIVIDED_CARD_TYPES, CardComponentDataProps } from '../dividedCard/DividedCard';

const numberOfLines = 3;
const componentConfigThemeKey = 'verticalCard';

type VerticalCardThemeProps = {
  cardBackgroundColor: string;
  cardTextColor: string;
  cardTextTypography: string;
  surfaceStyle: any;
  cardDecorationColor: string;
};

type Props = CardComponentDataProps & VerticalCardThemeProps;


const mapThemeProps = (theme: VerticalCardThemeProps): VerticalCardThemeProps => {
  return {
    cardBackgroundColor: theme.cardBackgroundColor,
    cardTextColor: theme.cardTextColor,
    cardTextTypography: theme.cardTextTypography,
    cardDecorationColor: theme.cardDecorationColor,
    surfaceStyle: theme.surfaceStyle,
  };
};

export const VerticalCard = (props: CardComponentDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <DividedCardComponent {...themeContext} {...props} dividedCardType={DIVIDED_CARD_TYPES.VERTICAL} showDecorationLine numberOfLines={numberOfLines} />;
};
